/**
 * The language our sentences are authored in, and therefore the last resort before showing a raw key.
 *
 * It lives in a module of its own — not next to the dictionaries it names — so that reading the CONSTANT
 * does not drag twenty-six dictionaries into the bundle along with it. See {@link ./bundled-registry} for
 * the 211 KB that mistake used to cost every shopper.
 */
/**
 * Not English: our sellers and their shoppers are francophone and arabophone, and the French text is the
 * one a human wrote rather than the one a machine produced.
 */
export const FALLBACK_LOCALE = 'fr';
//# sourceMappingURL=fallback.js.map